import * as React from 'react';
import Radium from '../../../../rostelecom/styling/rostelecom-radium';
import { IStoredDialogState } from '../../../../../../services/dialogs/dialogs-store';
import loginStore, { ILoginStoreState } from '../../../../../../services/login/login-store';
import settingsStore from '../../../../../../services/settings/settings-store';
import * as loginActions from '../../../../../../services/login/login-actions';
import { IRostelecomStyleParamsStoreState } from '../../../../rostelecom/styling/rostelecom-styles-store';
import { IReactRadiumFreeStyles } from '../../../../../base/radium-types';
import { ISettingsStoreState } from '../../../../../../services/settings/settings-types';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { emailConfirmationRequests } from '../../../../../../services/email-confirmation/email-confirmation-requests';
import rtkUserAccountRequest from '../../../../rostelecom/pages/users/rtk-user-account-request';

const i18nPrefix = 'js.auth.pages.request.email.confirmation.';
export const emailConfiramtionDialogId = 'emailConfiramtionDialogId';

export interface IConfirmationEmailDialogData {}
interface IProps {
    styles: IRostelecomStyleParamsStoreState;
    loginStore: ILoginStoreState;
    confirmEmailDialog: IStoredDialogState<IConfirmationEmailDialogData>;
}
interface IState {
    settings: ISettingsStoreState;
    login: ILoginStoreState;
}

@Radium
export class EmailConfirmationDialog extends InternationalizedComponent<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props, state);
        this.stores = {
            settings: settingsStore,
            login: loginStore
        };
        this.initialize();
        this.state = { ...this.state};
    }
    public async componentDidMount(): Promise<void> {
        try {
            const {email} = await rtkUserAccountRequest.getUserData();
            loginActions.setLoginState({email});
        } catch (e) {
            console.error(e);
        }
    }

    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styles;
        return {
            button: {
                color: styleParams.baseLightColor,
                backgroundColor: styleParams.baseMediumDarkColor,
                display: 'inline-block',
                padding: '0px 10px',
                margin: 0,
                textAlign: 'center',
                paddingFix: '0 40px',
                textDecoration: 'none',
                borderRadius: '3px',
                fontSize: '16px',
                boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                lineHeight: '34px',
                border: 'none',
                transition:
                    'box-shadow 0.15s ease-out, background-color 0.15s ease-out, color 0.15s ease-out',
                ':active': {
                    boxShadow: 'none'
                },
                ':hover': {
                    backgroundColor: styleParams.baseAccentColor
                }
            },
            desc: {
                lineHeight: '20px',
                wordSpacing: '3px'
            },
            linkStyle: {
                display: 'block',
                marginTop: 20,
                color: styleParams.baseMediumDarkColor
            },
            wrapper: {
                margin: '0 -60'
            },
            resend: {
                margin: '15px 0 22px 0'
            }
        };
    }
    private authUrl = () => (this.state.settings.sources.paths || {}).logout || '/logout/index';
    private redirectToAuthPage = (): void => window.location.replace(this.authUrl());

    private onRequestConfirmationLink = async () => {
        try {
            const {success} = await emailConfirmationRequests.sendConfirmationLink();
            if (success) {
                this.redirectToAuthPage();
            }
        } catch (e) {
            console.error(e);
        }
    };
    private getMessage = () => this.i18n(i18nPrefix + 'desc')
        .replace('{email}', this.props.loginStore.email);

    public render(): JSX.Element {
        const styles = this.getStyles();
        return (
            <React.Fragment>
                <div style={styles.wrapper}>
                    <h1 className="header">
                        {this.i18n(i18nPrefix + 'title')}
                    </h1>
                    <p style={styles.desc}>
                        {this.getMessage()}
                    </p>
                    <p style={styles.resend}>
                        {this.i18n(i18nPrefix + 'desc.resend')}
                    </p>
                </div>
                <button
                    onClick={this.onRequestConfirmationLink}
                    style={styles.button}
                >
                    {this.i18n(i18nPrefix + 'button.accept')}
                </button>
                <a href={this.authUrl()} style={styles.linkStyle}>
                    {this.i18n(i18nPrefix + 'button.to.auth')}
                </a>
            </React.Fragment>
        );
    }
}
